































































































































import { Component, Vue } from 'vue-property-decorator';
import { FitLayout } from '@/fit-ui';
import FitBackground from '@/fit-components/background/index.vue';
import LineChart from '@/components/line.vue';
import Header from '@/components/header.vue';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { showBusinessError } from '@/fit-components/dialog/main';
import { queryNews } from '../api';
import api from '../api/overseas';
import { NcovDataType } from '../types';
import { util, biHottag, language, url } from '@tencent/ppd-base-libs';
import { RouteName } from '../router';

import { i18n } from '@/i18n';
import { formatDate, diff_filter, thousands, maskZero } from '../util/index';
import Wegoods from '@/components/wegoods/index.vue';

@Component({
  components: {
    LineChart,
    FitBackground,
    FitLayout,
    Wegoods,
    Header,
  },
  filters: {
    diff_filter,
    thousands,
    maskZero,
  },
})
export default class GlobalPage extends Vue {
  // 最新全球疫情统计数据
  newestCase = {
    data: {}, // 统计数据
    updateTime: 0, // 更新时间
  };
  lang = language.getLanguage();
  // 地区数据
  regionCase = {
    data: [],
    size: 10, // 首次展示条数
    showAll: true, // 是否展示全部数据
  };
  serviceData: { jump_link: string; color: string; name: string }[] = [];
  thirdProduct: { name: string; desc: string; link: string }[] = [
    /* {name:i18n('Hygienium搓手液'), desc:i18n("歐洲製作，70%乙醇"), link:"https://hygienium.asia?t=1"},*/
    /* {name:i18n('口罩及消毒產品'), desc:i18n("美嘉健康旅遊提供"), link:"http://www.ohsmk.com/app/index.php?i=5&c=entry&m=ewei_shopv2&do=mobile"},*。
   /* {name:i18n('pricecom防疫產品'), desc:i18n("口罩及消毒清潔用品"), link:"https://offers.price.com.hk/index.php?id=729"}, */
    {
      name: i18n('3層过滤口罩'),
      desc: i18n('100% 香港製造'),
      link: 'https://offers.price.com.hk/product_detail.php?pid=193716',
    },
    {
      name: i18n('日本MASTO口罩'),
      desc: i18n('獨立包裝超柔軟'),
      link: 'https://offers.price.com.hk/product_detail.php?pid=193690',
    },
    {
      name: i18n('更多口罩消毒產品'),
      desc: i18n('由美嘉健康提供'),
      link: 'http://www.ohsmk.com/app/index.php?i=5&c=entry&m=ewei_shopv2&do=mobile',
    },
  ];
  // 曲线图展示相关配置信息
  lineChart = {
    columns: ['date', 'confirmed', 'death'],
    colors: ['#F45253', '#666666'],
    legendMap: {
      confirmed: i18n('確診個案'),
      death: i18n('死亡個案'),
    },
    rows: [],
    isShow: false,
  };
  // 是否展示分享弹框
  showShareDialog = false;
  reportTagList; // 用于记录SKU模块单个商品上报情况
  productMain;
  bannerVaccineData = {
    // 疫情banner
    link: 'https://www.fdh.labour.gov.hk/Leaflet_Vaccine.pdf',
  };
  // 获取最新确诊数据
  get newestCaseData() {
    const data = [];
    // 不同统计数据样式不一样
    const classList = ['item--error separator', 'item--dead separator', 'item--success'];
    let caseData = this.newestCase.data;
    caseData = Object.keys(caseData).length > 0 ? caseData : api.getDefNewstCaseData();

    Object.keys(caseData).forEach((key, i) => {
      if (key === 'territories') caseData[key].name = '國家/地區';
      data.push(
        // @ts-ignore
        Object.assign({ cssClass: classList[i] }, caseData[key]),
      );
    });
    console.log('caseData', caseData);
    return data;
  }

  // 获取地区数据
  get regionCaseData() {
    const regionData = this.regionCase;

    // 展示所有数据
    if (regionData.showAll) {
      return regionData.data;
    }
    const size = Math.min(regionData.size, regionData.data.length);
    return regionData.data.slice(0, size);
  }

  // 获取数据更新时间
  get updateTimeStr() {
    const time = this.newestCase.updateTime;
    return time ? formatDate(new Date(time * 1000)) : '-';
  }

  // 是否展示底部分享按钮
  get ifShowShare() {
    const adtag = url.getUrlParam('adtag');
    const hideShare = url.getUrlParam('hideShare');
    return adtag !== 'yellowbar' && !hideShare;
  }

  // 展示所有区域疫情信息
  showAllRegion() {
    this.regionCase.showAll = true;
    biHottag('wallet.cvirus.overseas.more_click');
  }

  // 跳转到指定服务
  goService(index) {
    setTimeout(() => {
      window.location.href = this.serviceData[index].jump_link;
    }, 32);
    biHottag(`wallet.cvirus.overseas.service${index + 1}_click`);
  }
  // 点击图表
  handleChartClick() {
    biHottag('wallet.cvirus.overseas.chart_click');
  }

  openShareDialog() {
    this.showShareDialog = true;
    biHottag('wallet.cvirus.overseas.share_click');
  }
  closeShareDialog() {
    this.showShareDialog = false;
  }

  goThirdProduct(index) {
    biHottag(`wallet.cvirus.overseas.pproduct${index + 1}_click`);
    setTimeout(() => {
      window.location.href = this.thirdProduct[index].link;
    }, 32);
  }

  activated() {
    util.changeTitle(i18n('全球防疫動態追蹤'));
    console.log('activated');
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 26);
  }
  goInsureService(index) {
    let link;
    if (index === 0) {
      link = 'https://heyavo.com/zh-hk/wechat-in-app?product=covid';
    } else if (index === 1) {
      link = 'https://heyavo.com/zh-hk/wechat-in-app?product=travel%2Fgba-wechat';
    }
    biHottag(`wallet.cvirus.home.avo${index + 1}_click`);

    setTimeout(() => {
      window.location.href = link;
    }, 300);
  }

  handleCVBannerClick(){
    biHottag('wallet.cvirus.home.banner_cv_click');
    setTimeout(() => {
      window.location.href = "https://prom.wechatpay.com.hk/app/promotion/gov_coupons/gov_coupon_home_page.cgi?ADTAG=epidemic#/";
    }, 300);
  }

  handleBannerVaccineClick() {
    // 疫情banner点击
    biHottag('wallet.cvirus.home.banner_vaccine_click');

    setTimeout(() => {
      window.location.href = this.bannerVaccineData.link;
    }, 300);
  }
  async created() {
    showLoading();
    try {
      // 查询全球疫情统计数据
      const caseData = await api.queryTotalCase();
      // 疫情统计数据

      this.newestCase = caseData.newstCase;
      // 折线图数据
      this.lineChart.rows = caseData.ncovData;
      this.lineChart.isShow = true;

      // 地区信息
      this.regionCase.data = await api.queryRegionCase();
      // 没有数据时显示已展示所有
      this.regionCase.showAll = !this.regionCase.data.length;

      // 获取服务信息
      const newsData = await queryNews();
      this.serviceData = newsData.service;
    } catch (error) {
      showBusinessError(error);
    }
    hideLoading();
    biHottag('wallet.cvirus.overseas.index_brow');
    setTimeout(() => {
      // 元素点击蒙层监听
      const needmaskEl = document.querySelectorAll('.touchmask');
      needmaskEl.forEach((v, i) => {
        v.addEventListener('touchstart', this.showMask);
        v.addEventListener('touchend', this.hideMask);
      });
    }, 1000);
  }
  showMask(e) {
    e.currentTarget.classList.add('showmask');
  }
  hideMask(e) {
    e.currentTarget.classList.remove('showmask');
  }
  mounted() {
    // 监听sku模块，当在可视区域内进行上报
    window.addEventListener('scroll', this.skuIsInViewPort);
    // 监听sku模块商品滑动进入可视区域时上报
    this.productMain = document.getElementById('product-main');
    this.productMain.addEventListener('scroll', this.productIsInViewPort);
  }

  // 监听SKU模块中商品数据，标记商品上报与否
  listenThirdProduct(data) {
    this.reportTagList = new Array(data.length).fill(false);
  }

  // 监听sku模块，当在可视区域内进行上报
  skuIsInViewPort() {
    console.log('执行方法');
    const thirdProductEL = document.getElementById('third-product');
    const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    if (thirdProductEL) {
      // 获取元素顶部及自身高度
      const height = thirdProductEL.getBoundingClientRect() && thirdProductEL.getBoundingClientRect().bottom;
      // 表示元素在可视区域内
      if (height <= viewPortHeight) {
        biHottag('wallet.goods.scenes.overseas_brow'); // 模块曝光上报，通过 fsource 区分频道
        window.removeEventListener('scroll', this.skuIsInViewPort);
        this.productIsInViewPort(); // 商品曝光上报，通过 fsource 区分频道
      }
    }
  }
  // 检查sku上报标记
  checkReportTag(value) {
    if (value) {
      return true;
    }
    return false;
  }
  // 监听sku模块，当在可视区域内进行上报
  productIsInViewPort() {
    // 检查是否已上报
    if (this.reportTagList instanceof Array && this.reportTagList.every(this.checkReportTag)) {
      this.productMain.removeEventListener('scroll', this.productIsInViewPort);
    }
    const mainEL = document.getElementById('product-main');
    if (mainEL) {
      // 获取商品节点
      const nodeList = mainEL.children;
      // 容器可视宽度
      const viewPortWidth = mainEL.offsetWidth;
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < nodeList.length; i++) {
        const leftSpace = nodeList[i].getBoundingClientRect() && nodeList[i].getBoundingClientRect().right;
        // 商品在可视区域内
        if (leftSpace <= viewPortWidth && !this.reportTagList[i]) {
          // 标记，防止重复上报
          this.reportTagList[i] = true;
          const reportAttrList = nodeList[i].id.split('_');
          biHottag('wallet.goods.scenes.productoverseas_brow', {
            fgoodsposition: `position_${reportAttrList[1]}`,
            fgoodsproduct: `product_${reportAttrList[3]}`,
          });
        }
      }
    }
  }
}
